var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-item"},[_c('div',{staticClass:"home-title"},[_c('h2',[_vm._v(_vm._s(_vm.english))]),_c('h1',[_vm._v(_vm._s(_vm.chinese))])]),_c('div',{staticClass:"box"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }